import { CgMenuBoxed } from "react-icons/cg"; 
import React from 'react';
import GxForm from '../../gx/GxForm';
import GxPrint from '../../gx/GxPrint';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxInput from '../../cx/CxInput';
import CxSearcher from '../../cx/CxSearcher';
import CxNumber from '../../cx/CxNumber';
import CxHidden from '../../cx/CxHidden';
import CxChooser from '../../cx/CxChooser';
import CxDate from '../../cx/CxDate';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxAccordion from '../../cx/CxAccordion';
import * as FxFetch from "../../fx/FxFetch";
import * as FxLog from '../../fx/FxLog';
import * as FxTable from '../../fx/FxTable';
import * as FxStr from '../../fx/FxStr';
import * as FxRegion from '../../fx/FxRegion';
import * as FxBrowser from '../../fx/FxBrowser';
import MxPsOTF from '../common/otf/MxPsOTF';
import '../../../styles/main.css';
import { StoreRxAuto, } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxIconButton from '../../cx/CxIconButton';
import CxDlgAlert from '../../cx/CxDlgAlert';
import { useWindowSize } from '../../hx/useWindowSize';
import { useAccess } from '../../hx/useAccess';
import CxSnackbar from '../../cx/CxSnackbar';
import CxCombo from '../../cx/CxCombo';
import CimavetSVG from '../../svg/CimavetSVG.jsx';
import MxPsRxAutoCimavetDlg from './MxPsRxAutoCimavetDlg';


const MxAnimalRxAutoFormItem = (props) => {
  const [{ trans }] = useTranslation();
  const [{ isFullAccess }] = useAccess(trans('field.rxs'));
  const [{ navBack }] = useNav();
  const size = useWindowSize();

  const r_form = React.useRef(null);
  const r_print = React.useRef(null);
  const r_dlg_new_ps = React.useRef(null);
  const r_dlg_alert = React.useRef(null);
  const r_dlg_cimavet = React.useRef(null);

  const r_snack_ask_save = React.useRef(null);

  const [labelQuantity, setLabelQuantity] = React.useState(trans('field.quantity'));
  const [labelQuantityTT, setLabelQuantityTT] = React.useState('');
  const [addFactor, setAddFactor] = React.useState(null);
  
  const rf_inRxAuto = React.useRef(null);
  const rf_txPs = React.useRef(null);
  const rf_nuQuantity = React.useRef(null);
  const rf_nuConversionFactor = React.useRef(null);
  const rf_txLotCode = React.useRef(null);
  const rf_dtLotExpr = React.useRef(null);

  const r_accordion_regime = React.useRef(null);
  
  const rf_txRegime = React.useRef(null);
  const rf_txTypeDispensing = React.useRef(null);
  const rf_txTypeTreatment = React.useRef(null);
  const rf_txCode = React.useRef(null);
  const rf_txDrugStrength = React.useRef(null);
  const rf_txNature = React.useRef(null);
  const rf_txPharmaceuticalForm = React.useRef(null);
  const rf_txRouteAdministration = React.useRef(null);
  const rf_txActiveIngredient = React.useRef(null);
  const rf_txDosageInformation = React.useRef(null);
  const rf_nuDrugPerc = React.useRef(null);
  const rf_txDurationTreatment = React.useRef(null);
  const rf_txWithdrawalMilk = React.useRef(null);
  const rf_txWithdrawalMeat = React.useRef(null);
  const rf_txWithdrawalEggs = React.useRef(null);
  const rf_txDirections = React.useRef(null);

  // eslint-disable-next-line no-unused-vars
  const [storeRxAuto, setStoreRxAuto] = useSessionStorage('StoreRxAuto', StoreRxAuto);

  let r_idx = React.useRef(storeRxAuto.idx);

  
  React.useEffect(() => {
    formLoadCustom();

    // eslint-disable-next-line
  }, []);

  const formLoadCustom = () => {
    if (storeRxAuto.idx === null) { //nuevo registro
      rf_txPs.current.setDlg(true); /* DAQ 2022.05.30 - abre automáticamente ventana de selección de producto-servicio */

    } else { // registro existente
      rf_inRxAuto.current.setVal(storeRxAuto.arItems[r_idx.current].inRxAuto);

      rf_txPs.current.setKey(storeRxAuto.arItems[r_idx.current].inPs);
      rf_txPs.current.setVal(storeRxAuto.arItems[r_idx.current].txPs);

      rf_nuQuantity.current.setVal(storeRxAuto.arItems[r_idx.current].nuQuantity);
      rf_nuConversionFactor.current.setVal(storeRxAuto.arItems[r_idx.current].nuConversionFactor);
      setAddFactor(storeRxAuto.arItems[r_idx.current].nuConversionFactor);
      updateLabelQuantity(storeRxAuto.arItems[r_idx.current].nuConversionFactor>0.0);
      rf_txLotCode.current.setVal(storeRxAuto.arItems[r_idx.current].txLotCode);
      rf_dtLotExpr.current.setVal(storeRxAuto.arItems[r_idx.current].dtLotExpr);

      loadRegimeControls(storeRxAuto.arItems[r_idx.current]);
    }
  }
  const formDeleteCustom = () => {
    FxLog.infox("MxAnimalRxAutoFormItem.formDeleteCustom", "..." + r_idx.current);
    if (storeRxAuto.idx !== null) {
      if (storeRxAuto.arItems[r_idx.current].inRxAuto) {
        storeRxAuto.txItemsDeleted = storeRxAuto.arItems[r_idx.current].inRxAuto + ' ' + storeRxAuto.txItemsDeleted;
      }
      storeRxAuto.arItems.splice(r_idx.current, 1); // 2nd parameter means remove one item only
      // reorder
      storeRxAuto.arItems.forEach(function (item, index) {
        item.idx = index;
      })

      // asienta que los datos fueron cambiados
      storeRxAuto.boDataChanged = '1';

      Promise.all([setStoreRxAuto(storeRxAuto)]).then((result) => {
        navBack();
      });
    }
  }

  const formLoadSelected = async (inPs) => {
    try {
      let record = {};
      record['idValue'] = inPs;
      return Promise.all([FxFetch.doJsonX(`rx_auto/r/ps/load_item_selected`, record)]).then((result) => {
        if (result[0]) {
          // 2025-02-26 - daq: si es un ps fraccionado, la cantidad del albarán es para la receta la fracción mínima.
          let nuConversionFactor = (result[0][0].nuConversionFactor>0.0 ? result[0][0].nuConversionFactor : 1);
          updateLabelQuantity(result[0][0].nuConversionFactor>0.0);

          // cargar controles
          rf_nuQuantity.current.setVal(result[0][0].nuQuantity / nuConversionFactor);
          rf_nuConversionFactor.current.setVal(result[0][0].nuConversionFactor);
          setAddFactor(result[0][0].nuConversionFactor);
          return result[0][0];
        }
      });

    } catch (error) {
      FxLog.errorx("MxAnimalRxAutoFormItem.formLoadSelected", error);
    }
  }

  const formSaveCustom = () => {
    if (r_form.current.hasIncompleteRequired()) {
      return;
    }

    let inPs = rf_txPs.current.getKey();
    Promise.all([saveItemToStore(inPs)]).then((result) => {
      navBack();
    });

  }

  const saveItemToStore = (inPs) => {
    try {
      let items = storeRxAuto.arItems || [];
      /*console.log("# of items: " + items.length);
      items.forEach(function(item, index) {
        console.log("[" + index + "]: " + item.txPs);
      });*/
    
      let _inPs = rf_txPs.current.getKey();
      let _txPs = rf_txPs.current.getVal();
      let _nuQuantity = rf_nuQuantity.current.getFloatVal();
      let _nuConversionFactor = rf_nuConversionFactor.current.getFloatVal();
      let _txLotCode = rf_txLotCode.current.getVal();
      let _dtLotExpr = rf_dtLotExpr.current.getVal();
      let _itRxAuto = rf_txRegime.current.getKey();

      let _txRegime = rf_txRegime.current.getVal();
      let _txTypeDispensing = rf_txTypeDispensing.current.getKey();
      let _txTypeTreatment = rf_txTypeTreatment.current.getKey();
      let _txCode = rf_txCode.current.getVal();
      let _txDrugStrength = rf_txDrugStrength.current.getVal();
      let _txNature = rf_txNature.current.getVal();
      let _txPharmaceuticalForm = rf_txPharmaceuticalForm.current.getVal();
      let _txRouteAdministration = rf_txRouteAdministration.current.getVal();
      let _txActiveIngredient = rf_txActiveIngredient.current.getVal();
      let _txDosageInformation = rf_txDosageInformation.current.getVal();
      let _nuDrugPerc = rf_nuDrugPerc.current.getValOrEmpty();
      let _txDurationTreatment = rf_txDurationTreatment.current.getVal();
      let _txWithdrawalMilk = rf_txWithdrawalMilk.current.getVal();
      let _txWithdrawalMeat = rf_txWithdrawalMeat.current.getVal();
      let _txWithdrawalEggs = rf_txWithdrawalEggs.current.getVal();

      let _txDirections = rf_txDirections.current.getVal();


      if (storeRxAuto.idx === null) {
        // Adding
        let item = {
          idx: 0,
          inRxAuto: FxStr.getRandomID(), // 2024-03-08 - daq: crea un identificador al azar.
          inPs: _inPs,
          txPs: _txPs,
          nuQuantity: _nuQuantity,
          nuConversionFactor: _nuConversionFactor,
          txLotCode: _txLotCode,
          dtLotExpr: _dtLotExpr,
          itRxAuto: _itRxAuto,
          txRegime: _txRegime,
          txTypeDispensing: _txTypeDispensing,
          nuDrugPerc: _nuDrugPerc,
          txTypeTreatment: _txTypeTreatment,
          txDurationTreatment: _txDurationTreatment,
          txDirections: _txDirections,
          txCode: _txCode,
          txDrugStrength: _txDrugStrength,
          txNature: _txNature,
          txPharmaceuticalForm: _txPharmaceuticalForm,
          txRouteAdministration: _txRouteAdministration,
          txActiveIngredient: _txActiveIngredient,
          txDosageInformation: _txDosageInformation,
          txWithdrawalMilk: _txWithdrawalMilk,
          txWithdrawalMeat: _txWithdrawalMeat,
          txWithdrawalEggs: _txWithdrawalEggs,
        };
        items.unshift(item);
        // reorder
        items.forEach(function (item, index) {
          item.idx = index;
        })
      } else {
        // Modifying
        storeRxAuto.arItems[r_idx.current].idx = storeRxAuto.idx;
        storeRxAuto.arItems[r_idx.current].inPs = _inPs;
        storeRxAuto.arItems[r_idx.current].txPs = _txPs;
        storeRxAuto.arItems[r_idx.current].nuQuantity = _nuQuantity;
        storeRxAuto.arItems[r_idx.current].txLotCode = _txLotCode;
        storeRxAuto.arItems[r_idx.current].dtLotExpr = _dtLotExpr;
        storeRxAuto.arItems[r_idx.current].itRxAuto = _itRxAuto;
        storeRxAuto.arItems[r_idx.current].txRegime = _txRegime;
        storeRxAuto.arItems[r_idx.current].txTypeDispensing = _txTypeDispensing;
        storeRxAuto.arItems[r_idx.current].nuDrugPerc = _nuDrugPerc;
        storeRxAuto.arItems[r_idx.current].txTypeTreatment = _txTypeTreatment;
        storeRxAuto.arItems[r_idx.current].txDurationTreatment = _txDurationTreatment;
        storeRxAuto.arItems[r_idx.current].txDirections = _txDirections;
        storeRxAuto.arItems[r_idx.current].txCode = _txCode;
        storeRxAuto.arItems[r_idx.current].txDrugStrength = _txDrugStrength;
        storeRxAuto.arItems[r_idx.current].txNature = _txNature;
        storeRxAuto.arItems[r_idx.current].txPharmaceuticalForm = _txPharmaceuticalForm;
        storeRxAuto.arItems[r_idx.current].txRouteAdministration = _txRouteAdministration;
        storeRxAuto.arItems[r_idx.current].txActiveIngredient = _txActiveIngredient;
        storeRxAuto.arItems[r_idx.current].txDosageInformation = _txDosageInformation;
        storeRxAuto.arItems[r_idx.current].txWithdrawalMilk = _txWithdrawalMilk;
        storeRxAuto.arItems[r_idx.current].txWithdrawalMeat = _txWithdrawalMeat;
        storeRxAuto.arItems[r_idx.current].txWithdrawalEggs = _txWithdrawalEggs;
      }

      //console.log("Added item: " + item.txPs);
      storeRxAuto.arItems = items;

      // asienta que los datos fueron cambiados
      storeRxAuto.boDataChanged = '1';

      // Saving
      setStoreRxAuto(storeRxAuto);

    } catch (error) {
      FxLog.errorx('MxAnimalRxAutoFormItem.saveItemToStore', error)
    }

  }

  const lotChanged = async (row) => {
    if (row) {
      rf_dtLotExpr.current.setVal(row.original.dtLotExpr);
    }
  }

  const psClear = () => {
    rf_nuQuantity.current.setVal('');
    rf_nuConversionFactor.current.setVal('');
    rf_txLotCode.current.setVal('');
    rf_txLotCode.current.setFilter(`false`);
    rf_dtLotExpr.current.setVal('');
    setAddFactor(null);
    regimeCleared();
  }
  const regimeCleared = () => {
    rf_txRegime.current.setVal('');
    rf_txRegime.current.setFilter(rf_txPs.current.getKey() ? `t_rx_auto.inPs='${rf_txPs.current.getKey()}'` : `false`);
    rf_txTypeDispensing.current.clear(); // .setKeyAndVal('D', trans('field.rx_dispensing_dispensation'));
    rf_txTypeTreatment.current.clear(); // .setKeyAndVal('T', trans('field.rx_treatment_therapeutic'));
    rf_txCode.current.setVal('');
    rf_txDrugStrength.current.setVal('');
    rf_txNature.current.setVal('');
    rf_txPharmaceuticalForm.current.setVal('');
    rf_txRouteAdministration.current.setVal('');
    rf_txActiveIngredient.current.setVal('');
    rf_txDosageInformation.current.setVal('');
    rf_nuDrugPerc.current.setVal('');
    rf_txDurationTreatment.current.setVal('');
    rf_txWithdrawalMilk.current.setVal('');
    rf_txWithdrawalMeat.current.setVal('');
    rf_txWithdrawalEggs.current.setVal('');
    rf_txDirections.current.setVal('');
  }

  const loadRegimeControls = (data) => {
    FxLog.infox('MxAnimalRxAutoFormItem.loadRegimeControls', '...data:', data);
    
    rf_txRegime.current.setKey(data.itRxAuto);
    rf_txRegime.current.setVal(data.txRegime);
    rf_txRegime.current.setFilter(`t_rx_auto.inPs='${data.inPs}'`);

    rf_txTypeDispensing.current.setKeyAndVal(
      data.txTypeDispensing,
      FxStr.choose(data.txTypeDispensing, 'D|N|K',
        trans('field.rx_dispensing_dispensation'),
        trans('field.rx_dispensing_dispensation_no'),
        trans('field.rx_dispensing_kit')
      ));

    rf_txTypeTreatment.current.setKeyAndVal(
      data.txTypeTreatment,
      FxStr.choose(data.txTypeTreatment, 'T|M|P',
        trans('field.rx_treatment_therapeutic'),
        trans('field.rx_treatment_metaphylactic'),
        trans('field.rx_treatment_prophylactic')
      ));

    rf_txCode.current.setVal(data.txCode);
    rf_txDrugStrength.current.setVal(data.txDrugStrength);
    rf_txNature.current.setVal(data.txNature);
    rf_txPharmaceuticalForm.current.setVal(data.txPharmaceuticalForm);
    rf_txRouteAdministration.current.setVal(data.txRouteAdministration);
    rf_txActiveIngredient.current.setVal(data.txActiveIngredient);
    rf_txDosageInformation.current.setVal(data.txDosageInformation);
    rf_nuDrugPerc.current.setVal(data.nuDrugPerc);
    rf_txDurationTreatment.current.setVal(data.txDurationTreatment);
    rf_txWithdrawalMilk.current.setVal(data.txWithdrawalMilk);
    rf_txWithdrawalMeat.current.setVal(data.txWithdrawalMeat);
    rf_txWithdrawalEggs.current.setVal(data.txWithdrawalEggs);
    
    rf_txDirections.current.setVal(data.txDirections);

  }

  const psChanged = async (row) => {
    if (row !== null) {
      psClear();
      let inPs = row.original.inPs;
      Promise.all([formLoadSelected(inPs)]).then((result) => {
        FxLog.infox('MxAnimalRxAutoFormItem.psChanged', '...result:', result[0]);
        // lote
        rf_txLotCode.current.setFilter(`n_pur_invoice_item.inPs='${inPs}'`);
        // régimen
        rf_txRegime.current.setFilter(`t_rx_auto.inPs='${inPs}'`);
        // 2025-01-28 - daq: si el ps tiene algún régimen, le damos para seleccionar uno.
        if (result[0].itRxAuto) {
          rf_txRegime.current.search();
        }
      });
    }
  }

  const updateLabelQuantity = (isBulkProduct) => {
    if (isBulkProduct) {
      setLabelQuantity(`${trans('field.quantity')} (${trans('field.bulk_product')})`);
      setLabelQuantityTT(`${trans('field.units')} / ${trans('field.conversion_factor')}`);
    } else {
      setLabelQuantity(trans('field.quantity'));
      setLabelQuantityTT('');
    }
  }

  const selectedPsOTF = (inPs, txPs) => {
    try {
      rf_txPs.current.setKey(inPs);
      rf_txPs.current.setVal(txPs);
      formLoadSelected(inPs);

    } catch (error) {
      FxLog.errorx('MxAnimalRxAutoFormItem.selectedPsOTF', error)
    }
  }

  const regimeSelected = (row) => {
    FxLog.infox('MxAnimalRxAutoFormItem.regimeSelected', '...row.original.itRxAuto:', row.original.itRxAuto);
    let record = {};
    record['idValue'] = row.original.itRxAuto;
    Promise.all([FxFetch.doJsonX(`pss/rx_auto/r`, record)]).then((result) => {
      if (result[0]) {
        // cargar controles
        loadRegimeControls(result[0][0]);
      }
    });
  }

  const doCimavetInsert = (drugData) => {
    FxLog.infox('MxPsRxAutoForm.doCimavetInsert', '...drugData:', drugData);
    if (rf_txRegime.current.isEmpty()) rf_txRegime.current.setVal(trans('field.regular'));
    rf_txTypeDispensing.current.setKeyAndVal2(drugData.txTypeDispensing);
    rf_txTypeTreatment.current.setKeyAndVal2(drugData.txTypeTreatment);
    rf_txCode.current.setVal(drugData.txCode);
    rf_txDrugStrength.current.setVal(drugData.txDrugStrength);
    rf_txNature.current.setVal(drugData.txNature);

    rf_txPharmaceuticalForm.current.setVal(drugData.txPharmaceuticalForm);
    rf_txRouteAdministration.current.setVal(drugData.txRouteAdministration);
    rf_txActiveIngredient.current.setVal(drugData.txActiveIngredient);
    rf_txDosageInformation.current.setVal(drugData.txDosageInformation);
    rf_nuDrugPerc.current.setVal(drugData.nuDrugPerc);
    rf_txDurationTreatment.current.setVal(drugData.txDurationTreatment);
    rf_txWithdrawalMilk.current.setVal(drugData.txWithdrawalMilk);
    rf_txWithdrawalMeat.current.setVal(drugData.txWithdrawalMeat);
    rf_txWithdrawalEggs.current.setVal(drugData.txWithdrawalEggs);
    //setUrlTechSheet(drugData.url);
  }

  const doPrintXLabel = async (option) => {
    if (!rf_inRxAuto.current.getVal()) {
      r_snack_ask_save.current.setOpen(true);
      return;
    }
    let filter = {};
    filter['reportFormat'] = `PDF`;
    filter['inRxAuto'] = `${rf_inRxAuto.current.getVal()}`;
    filter['docSize'] = 'LB';
    let record = {};
    r_print.current.setScale(2);
    r_print.current.setUrl('rx_auto/report');
    //----------------
    Promise.all([
      r_print.current.setFilter(filter),
      r_print.current.setRecord(record),
    ]).then((result) => {
      r_print.current.doPrint();
    });
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.rxs')}: ${trans('field.item')}`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>

            {/* botón importar de cimavet */}
            {FxRegion.isSpain() && <CxIconButtonNew 
              icon={<CimavetSVG fill='var(--ibs_color_blue)' width="70.00px" height="20.00px" />} 
              classType="ibs_iconbutton_toolbar" 
              onClick={() => r_dlg_cimavet.current.setOpenDlg(true)} 
              tooltip={'Importar datos de Cimavet'} 
            />}

            {/* botón de impresión */}
            {storeRxAuto.idx !== null && storeRxAuto.inRxAuto
              && <CxIconButtonNew icon={<CgMenuBoxed fontSize="25px" />} classType="ibs_iconbutton_toolbar" onClick={() => doPrintXLabel()} tooltip={`${trans('field.print')} ${trans('field.label')}`} />}

            {/* botón borrar */}
            {storeRxAuto.idx !== null && isFullAccess()
              && <CxIconButton type="cancel" classType="ibs_iconbutton_toolbar" onClick={() => formDeleteCustom()} />}

            {/* botón guardar */}
            {isFullAccess()
              && <CxIconButton type="accept" classType="ibs_iconbutton_toolbar" onClick={() => formSaveCustom()} />}
          </div>
        }
      >

        <CxHidden xref={rf_inRxAuto} />
        <CxHidden xref={rf_nuConversionFactor} />

        <CxSearcher xref={rf_txPs} id='MxAnimalRxAutoFormItem_txPs'
          label={trans('field.rx_drug_name')}
          readOnly={storeRxAuto.rf_inRxAuto}
          onSelection={psChanged}
          onClear={psClear}
          onButtonAddOTF={() => {
            rf_txPs.current.setDlg(false);
            r_dlg_new_ps.current.setDlg(true);
          }}
          url="pss"
          col_id="inPs"
          col_tx="txPs"
          filter={'n_ps.nuNature = 0'}
          tooltip={`${trans('field.ps')} / ${trans('field.code')}`}
          refColors={['table_cell_color_brown|' + trans('field.composite'), 'table_cell_color_green|' + trans('field.frequency')]}
          columns={[
            { id: "0", Header: "ID", accessor: "inPs", show: false },
            { id: "1", Header: trans('field.ps'), accessor: row => rf_txPs.current.getTable().highlightText(row["txPs"]), width: '50%' },
            { id: "2", Header: trans('field.code'), accessor: row => rf_txPs.current.getTable().highlightText(row["txPsCode"]), width: '25%', align: 'right', show: size.isLarge },
            { id: "3", Header: trans('field.total'), accessor: row => FxTable.cellTo2r00(row["theTotalPrice"]), width: '25%', align: 'right' },
            { id: "W", Header: "_composite", accessor: row => Boolean(row["boComposite"] === '1'), show: false },
            { id: "G", Header: "_frequency", accessor: row => Boolean(row["nuFrequency"] > 0), show: false },
          ]}
          required
        />

        <CxNumber xref={rf_nuQuantity} 
          label={labelQuantity} labelTooltip={labelQuantityTT} 
          decimals={4} 
          decimalsfixed="true" 
          autoselect="true"
          sumButton={1/addFactor} 
          required 
        />

        <CxSearcher xref={rf_txLotCode} id='MxAnimalRxAutoFormItem_txLotCode'
          label={trans('field.rx_lot_code')}
          onSelection={lotChanged}
          onClear={lotChanged}
          url="rx_auto/lots"
          col_id="inPurInvoiceItem"
          col_tx="txLotCode"
          tooltip={`${trans('field.lot')}`}
          columns={[
            { id: "0", Header: "ID", accessor: "inPurInvoiceItem", show: false },
            { id: "1", Header: trans('field.lot'), accessor: row => rf_txLotCode.current.getTable().highlightText(row["txLotCode"]), width: '50%' },
            { id: "2", Header: trans('field.expiration'), accessor: row => FxTable.cellToLocalDate(row["dtLotExpr"]), width: '25%' },
            { id: "3", Header: trans('field.quantity'), accessor: row => FxTable.cellTo2r00(row["nuQuantity"]), width: '25%', align: 'right' },
          ]}
        />
        <CxDate xref={rf_dtLotExpr} label={trans('field.rx_expiration')} />

        {/* --------------------------------------------------------------------------------------- */}
        <CxAccordion xref={r_accordion_regime} 
          title={`${trans('field.rx')}-${trans('field.rx_regime')}`} 
          background={"var(--ibs_color_gray_light)"} 
          color={"var(--ibs_color_black)"} 
          defaultExpanded={FxRegion.isSpain()} 
        >

          <CxChooser xref={rf_txRegime} 
            label={trans('field.rx_regime')}
            table="t_rx_auto"
            col_id="itRxAuto"
            col_tx="txRegime"
            filter={`false`}
            onSelection={regimeSelected}
            onClear={regimeCleared}
            bottomLegend={`${trans('msg.setup_new_1')}: ${trans('field.pss')} > ${trans('field.file')} > ${trans('field.rx')}-${trans('field.rx_regime')}`}
            /* required={FxRegion.isSpain()} quitamos porque es.meraki necesita hacerlo sin eso */
          />

          {/* 1-dispensación (almacenado en farmacia), 2-no-dispensación, 3-botiquín (almacenado en explotación) */}
          <CxCombo xref={rf_txTypeDispensing}
            label={`${trans('field.rx_type_dispensing')}`}
            list={[
              { id: 'D', type: trans('field.rx_dispensing_dispensation') },
              { id: 'N', type: trans('field.rx_dispensing_dispensation_no') },
              { id: 'K', type: trans('field.rx_dispensing_kit') },
            ]}
            //defaultValue='D'
            //clearDisabled
          />

          {/* T-terapéutico, M-metafiláctico, P-profiláctico */}
          <CxCombo xref={rf_txTypeTreatment}
            label={`${trans('field.rx_type_treatment')}`}
            list={[
              { id: 'T', type: trans('field.rx_treatment_therapeutic') },
              { id: 'M', type: trans('field.rx_treatment_metaphylactic') },
              { id: 'P', type: trans('field.rx_treatment_prophylactic') },
            ]}
            //defaultValue='T'
            //clearDisabled
          />

          {FxRegion.isSpain() && <CxInput xref={rf_txCode} label={trans('field.rx_national_code')} dbfield="t_rx_auto.txCode" maxLength='30' onInfo={() => FxBrowser.windowOpen('https://cimavet.aemps.es/cimavet/publico/home.html')} />}
          {!FxRegion.isSpain() && <CxInput xref={rf_txCode} label={trans('field.rx_national_code')} dbfield="t_rx_auto.txCode" maxLength='30' />}
          <CxInput xref={rf_txDrugStrength} label={trans('field.rx_drug_strength')} dbfield="t_rx_auto.txDrugStrength" maxLength='255' /> 
          <CxInput xref={rf_txNature} label={trans('field.rx_nature')} dbfield="t_rx_auto.txNature" maxLength='255' />

          <CxInput xref={rf_txPharmaceuticalForm} label={trans('field.rx_pharmaceutical_form')} dbfield="t_rx_auto.txPharmaceuticalForm" maxLength='255' />
          <CxInput xref={rf_txRouteAdministration} label={trans('field.rx_route_administration')} dbfield="t_rx_auto.txRouteAdministration" maxLength='255' />
          <CxInput xref={rf_txActiveIngredient} label={trans('field.rx_active_ingredient')} dbfield="t_rx_auto.txActiveIngredient" maxLength='255' />
          <CxInput xref={rf_txDosageInformation} label={trans('field.rx_dosage_information')} dbfield="t_rx_auto.txDosageInformation" maxLength='255' />

          <CxNumber xref={rf_nuDrugPerc} label={trans('field.rx_drug_perc')} decimals={1} decimalsfixed="false" defaultValue={100} />
          <CxInput xref={rf_txDurationTreatment} label={trans('field.rx_duration_treatment')} maxLength='255' />

          <CxInput xref={rf_txWithdrawalMilk} label={trans('field.rx_withdrawal_milk')} dbfield="t_rx_auto.txWithdrawalMilk" maxLength='255' />
          <CxInput xref={rf_txWithdrawalMeat} label={trans('field.rx_withdrawal_meat')} dbfield="t_rx_auto.txWithdrawalMeat" maxLength='255' />
          <CxInput xref={rf_txWithdrawalEggs} label={trans('field.rx_withdrawal_eggs')} dbfield="t_rx_auto.txWithdrawalEggs" maxLength='255' />

        </CxAccordion>

        <CxInput xref={rf_txDirections} label={trans('field.rx_directions')} maxLength='500' minRows={4} />

        {/* --------------------------------------------------------------------------------------- */}

        <MxPsOTF xref={r_dlg_new_ps} onOk={selectedPsOTF} />

      </GxForm>

      <CxSnackbar xref={r_snack_ask_save} severity="error" value={trans('msg.save_x_before', 'field.doc')} />
      <CxDlgAlert xref={r_dlg_alert} />
      <GxPrint xref={r_print} />

      <MxPsRxAutoCimavetDlg
        xref={r_dlg_cimavet}
        title={'Importar datos de Cimavet'}
        onResult={doCimavetInsert}
      />

    </div>
  );

}

export default MxAnimalRxAutoFormItem;
